import { actions } from "./actionTypes";
import AccountService from "services/account.service";
import { logout } from "services/profile.services";
import { alertActions } from "actions/alert.actions";
import { getAppInfo } from "actions/appInfo";
import { actions as domainActions } from "actions/domains/actionTypes";
import {} from "actions/domains/actionTypes";
import { get } from "lodash";

export const getProfile = () => {
  return (dispatch: any) => {
    dispatch(actions.getProfile());
    AccountService.getProfile()
      .then((res: any) => {
        dispatch(actions.getProfileSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getProfileFail(err));
      });
  };
};

export const deployApp = (domain: string) => {
  return (dispatch: any) => {
    dispatch(actions.deployApp());
    return AccountService.deploy(domain)
      .then((res: any) => {
        console.log("here");
        dispatch(actions.deployAppSuccess(res?.data));
        dispatch(getAppInfo());
      })
      .catch((err) => {
        dispatch(alertActions.error(err?.message));
        dispatch(actions.deployAppFail(err?.message));
      });
  };
};

export const updateProfile = (params: any) => {
  return (dispatch: any) => {
    dispatch(actions.updateProfile());
    AccountService.updateProfile(params)
      .then((res: any) => {
        dispatch(actions.updateProfileSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.updateProfileFail(err?.message));
      });
  };
};

export const changePassword = (params: any) => {
  return (dispatch: any) => {
    dispatch(actions.changePassword());
    AccountService.changePassword(params)
      .then((res: any) => {
        // dispatch(alertActions.success('Change Password Successed'));
        dispatch(alertActions.success("Your password has been changed!"));
        dispatch(actions.changePasswordSuccess(res?.data));
        logout();
      })
      .catch((err) => {
        dispatch(actions.changePasswordFail(err));
        dispatch(alertActions.error(err?.message));
      });
  };
};

export const confirmSubcription = (params: any) => {
  return (dispatch: any) => {
    dispatch(actions.confirmSubcription());
    AccountService.confirmSubcription(params)
      .then((res) => {
        dispatch(actions.confirmSubcriptionSuccess());
      })
      .catch((err) => {
        dispatch(actions.confirmSubcriptionFail());
      });
  };
};

export const setupStripe = (code: string) => {
  return (dispatch: any) => {
    dispatch(actions.setupStripe());
    AccountService.setupStripe(code)
      .then((res: any) => {
        const { url } = res?.data;
        if (url) {
          window.location.replace(url);
          dispatch(actions.setupStripeSuccess());
        }
      })
      .catch((err: any) => {
        dispatch(actions.setupStripeFail(err));
      });
  };
};

export const cancelSubscription = () => {
  return (dispatch: any) => {
    dispatch(actions.cancelSubscription());
    AccountService.cancelSubscription()
      .then((res) => {
        dispatch(actions.cancelSubscriptionSuccess());
        dispatch(getProfile());
      })
      .catch((err) => {
        dispatch(actions.cancelSubscriptionFail(err));
      });
  };
};

export const subscriptionStripe = () => {
  return (dispatch: any) => {
    dispatch(actions.subscriptionStripe());
    AccountService.subscriptionStripe()
      .then(async (res) => {
        dispatch(actions.subscriptionStripeSuccess());
        // const stripe = await loadStripe(
        //   process.env.REACT_APP_STRIP_API_KEY as string
        // );
        const url = get(res, "data.url");

        // if (stripe && sessionId) {
        //   await stripe.redirectToCheckout({
        //     sessionId: sessionId,
        //   });
        // }
        if (url) {
          window.location.replace(url);
        }
        dispatch(getProfile());
      })
      .catch((err) => {
        dispatch(actions.subscriptionStripeFail(err));
      });
  };
};

export const clearErrorChangeProfile = () => {
  return (dispatch: any) => {
    dispatch(actions.clearErrorChangeProfile());
  };
};

export const clearLoadingLogin = () => {
  return (dispatch: any) => {
    dispatch(actions.clearLoadingLogin());
  };
};

export const refreshToken = () => {
  return async (dispatch: any) => {
    dispatch(actions.refreshToken());
    return AccountService.refreshToken()
      .then((res: any) => {
        // console.log("res", res);
        // console.log(JSON.stringify(res?.data));
        dispatch(actions.refreshTokenSuccess(res?.data));
        //dispatch(AccountActionTypes.actions.getProfileSuccess(res?.data));
        window.location.reload();
        return;
      })
      .catch((err) => {
        console.log("err", err);
        logout();
      });
  };
};

export const sendSupportEmail = (params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.sendSupportEmail());
    return AccountService.sendSupport(params)
      .then((res: any) => {
        dispatch(alertActions.success("Your concern has been sent to us!"));
        dispatch(actions.sendSupportEmailSuccess());
      })
      .catch((err) => {
        dispatch(actions.sendSupportEmailFail(err));
      });
  };
};
